// fake-calendar-data.js
import { clone } from "lodash"
import moment from "moment"

const startDate = moment().startOf("day").format("YYYY-MM-DD")
const endDate = moment().endOf("day").format("YYYY-MM-DD")

const currentWeek = moment().week()
const daysOfWeek = []

for (let i = 0; i <= 7; i++) {
  const day = moment().week(currentWeek).day(i)
  daysOfWeek.push(day.format("YYYY-MM-DD"))
}

const fakeCalendarData = {
  status: true,
  message: null,
  data: {
    ptDemoList: [
      {
        id: 5768769,
        userId: 7717,
        email: "sinta.mustikawati@apollo.edu.vn",
        fullNameEN: "Sinta Dwi Mustikawati",
        eventName: "PH-PT-22/05/25-048",
        eventTypeId: 1,
        eventTypeName: "PT",
        startTime: `${startDate} 01:15:00.000`,
        endTime: `${endDate} 04:15:00.000`,
        centerId: 33,
        centerCode: "HN1.PH",
        centerName: "Pho Hue",
        appointment: null,
      },
    ],
    classSessionScheduleList: [
      {
        id: 69921948,
        className: "NGD24-Kindergarten 2",
        curriculumName: "Kindergarten 2",
        classCode: "HN212212-C00012-8465",
        startTime: `${startDate} 17:15:00.000`,
        endTime: `${endDate} 21:35:00.000`,
        centerName: "Ngoai Giao Doan",
      },
    ],
    testEOCCList: [
      {
        classSessionId: 71076453,
        teacherId: 7717,
        sessionName: "B-46",
        groupKoc: "AGLS",
        koc: "Primary",
        duration: 2,
        className: "PH - PRI3 - 0237",
        startTime: `${startDate} 10:00:00.000`,
        endTime: `${endDate} 12:00:00.000`,
        event: "Productive test B",
      },
    ],
    feedback: [
      {
        feedBackId: 123557,
        feedBackTrackingId: 6,
        createdDate: `${startDate} 14:58:00.000`,
        modifiedDate: `${endDate} 18:59:11.604`,
        feedBackSubject: "Asking about learning program",
        deadlineDate: `${endDate} 18:59:11.604`,
        studentCode: "HN1230608073",
        studentName: "Phạm Nam Sơn",
        classCode: "HN12310-C00022-5994",
        className: "PH(217) - Primary 2",
        createdBy: 10875,
        suggestedResponse: "",
        feedBackContent:
          "Call EPP: Mom has consider that the school she wants her son to enter will need a Tofel Primary certificate, but she saw Apollo teaches according to Cambridge program, she is concerned Apollo programs will go against her orientations.",
        finalResponseFromParents:
          "Van called his mother, she shared that she will ask again about her child's orientation. Van shared with mom that no matter what certificate he takes, the exam will be converted according to the common European measure CEFR. Mom said she no longer wants her child to study at Nguyen Sieu, she plans to send her child to an international school such as Vinschool,...",
        feedBackCode: "FB2024-020873",
        centerName: "Pho Hue",
        centerCode: "HN1.PH",
        feedbackNoteEntity: null,
      },
    ],
    dailyReports: [
      {
        dailyReportId: "70844438-7928783",
        classId: 53499,
        className: "PH - PRI2 - 0230",
        sessionId: 70844438,
        sessionName: "C-54",
        teacherId: 7717,
        lessonReportPublishedTime: null,
        status: "NOT_COMPLETE",
        sessionDate: `${startDate} 10:20:00.000`,
        sessionStartTime: `${startDate} 10:25:00.000`,
        sessionEndTime: `${endDate} 19:25:00.000`,
        deadline: `${endDate} 15:25:00.000`,
      },
    ],
    progressReports: [
      {
        progressReportId: "235481",
        teacherId: 7717,
        progress: "Primary 3 - Progress report 2",
        publishedDate: "2025-05-10 13:55:30.920",
        deadline: `${endDate} 00:01:42.335`,
        classId: 54483,
        className: "PH - PRI3 - 0806",
        status: "COMPLETED_OVERDUE",
        createOn: "2025-04-18 00:01:41.664",
        completedDate: "2025-04-25 01:36:40.158",
      },
    ],
    otherTasks: [],
    gradeBookReports: [
      {
        gradeBookReportId: "10336-144527",
        classId: 58374,
        classSession: 1,
        className: "TC - SEC2 - 0008",
        mainTeacherId: 7717,
        mainTeacherName: "Sinta Dwi Mustikawati",
        gradeBookName: "Primary 1 - Gradebook report B",
        gradeBookDue: `${startDate} 00:00:42.335`,
        gradeBookFinished: `${endDate} 00:09:42.335`,
        status: "COMPLETED_OVERDUE",
        createOn: `${startDate} 00:00:42.335`,
        completedDate: `${endDate} 00:10:42.335`,
      },
    ],
    studentAtRiskTask: [
      {
        id: 648953575,
        studentId: 545878,
        teacherName: "Sinta Dwi Mustikawati",
        classCode: "HN242504-C00032-2242",
        className: "TC - SEC2 - 0008",
        engagementStatus: "OFFTRACK",
        homeLearningStatus: "OFFTRACK",
        performanceStatus: "OFFTRACK",
        startTime: `${startDate} 13:00:00.000`,
        endTime: `${endDate} 15:00:00.000`,
        cutOffDate: `${endDate}`,
        classId: 58374,
        studentName: "Lê Thiện An",
        nickName: null,
        continuousStatus: "1 WEEK",
        overallStatus: "OFFTRACK",
        studentCode: "HN24240302261",
      },
    ],
  },
}

const ptDemoList = fakeCalendarData.data.ptDemoList
const classSessionScheduleList = fakeCalendarData.data.classSessionScheduleList
const testEOCCList = fakeCalendarData.data.testEOCCList
const dailyReports = fakeCalendarData.data.dailyReports
const feedback = fakeCalendarData.data.feedback
const studentAtRiskTask = fakeCalendarData.data.studentAtRiskTask

const clonedPtDemoList = []
const clonedClassSessionScheduleList = []
const clonedTestEOCCList = []
const clonedDailyReports = []
const clonedFeedback = []
const clonedStudentAtRiskTask = []

for (let i = 0; i <= 7; i++) {
  const clonedPtDemoItem = { ...ptDemoList[0] }
  clonedPtDemoItem.startTime = `${daysOfWeek[i]} 01:15:00.000`
  clonedPtDemoItem.endTime = `${daysOfWeek[i]} 04:15:00.000`
  clonedPtDemoList.push(clonedPtDemoItem)

  const clonedClassSessionScheduleItem = { ...classSessionScheduleList[0] }
  clonedClassSessionScheduleItem.startTime = `${daysOfWeek[i]} 15:15:00.000`
  clonedClassSessionScheduleItem.endTime = `${daysOfWeek[i]} 21:35:00.000`
  clonedClassSessionScheduleList.push(clonedClassSessionScheduleItem)

  const clonedTestEOCCItem = { ...testEOCCList[0] }
  clonedTestEOCCItem.startTime = `${daysOfWeek[i]} 10:00:00.000`
  clonedTestEOCCItem.endTime = `${daysOfWeek[i]} 12:00:00.000`
  clonedTestEOCCList.push(clonedTestEOCCItem)

  const clonedDailyReportItem = { ...dailyReports[0] }
  clonedDailyReportItem.sessionDate = `${daysOfWeek[i]} 10:00:00.000`
  clonedDailyReportItem.sessionStartTime = `${daysOfWeek[i]} 10:25:00.000`
  clonedDailyReportItem.sessionEndTime = `${daysOfWeek[i]} 17:25:00.000`
  clonedDailyReportItem.deadline = `${daysOfWeek[i]} 18:25:00.000`
  clonedDailyReports.push(clonedDailyReportItem)

  const clonedFeedbackItem = { ...feedback[0] }
  clonedFeedbackItem.startTime = `${daysOfWeek[i]} 13:00:00.000`
  clonedFeedbackItem.endTime = `${daysOfWeek[i]} 14:00:00.000`
  clonedFeedbackItem.deadlineDate = `${daysOfWeek[i]} 14:30:00.000`
  clonedFeedback.push(clonedFeedbackItem)

  const clonedStudentAtRiskTaskItem = { ...studentAtRiskTask[0] }
  clonedStudentAtRiskTaskItem.startTime = `${daysOfWeek[i]} 13:00:00.000`
  clonedStudentAtRiskTaskItem.endTime = `${daysOfWeek[i]} 15:00:00.000`
  clonedStudentAtRiskTaskItem.cutOffDate = `${daysOfWeek[i]} 18:00:00.000`
  clonedStudentAtRiskTaskItem.className = `${studentAtRiskTask[0].className}-${
    i + 1
  }`
  clonedStudentAtRiskTask.push(clonedStudentAtRiskTaskItem)
}

fakeCalendarData.data.ptDemoList = clonedPtDemoList
fakeCalendarData.data.classSessionScheduleList = clonedClassSessionScheduleList
fakeCalendarData.data.testEOCCList = clonedTestEOCCList
fakeCalendarData.data.dailyReports = clonedDailyReports
fakeCalendarData.data.feedback = clonedFeedback
fakeCalendarData.data.studentAtRiskTask = clonedStudentAtRiskTask

export const createMockApiResponse = () => {
  const mockResult = {
    data: fakeCalendarData,
    isFetching: false,
  }

  const triggerClassSession = (params) => {
    // console.log("triggerClassSession called with params:", params); // Debug log
    return mockResult
  }

  return [triggerClassSession, mockResult]
}

export default fakeCalendarData
